import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { afterItems, beforeItems } from "../data/framework";
export function BeforeAfterSection() {
  return <Section tone="white" labelledBy="ba-title" cta="I want to review facelift cases with a system" data-id="element-46" data-mp="pou10mhu42cu">
      <SectionHeading id="ba-title" title="What You Can Expect From a More Structured Review Process" data-id="element-47" data-mp="kw0v3vamqnz6" />

      <div className="mt-10 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-48" data-mp="zknafx09bfqe">
        <div className="rounded-3xl border border-rose/15 bg-rose-soft p-6 sm:p-8" data-id="element-49" data-mp="unes9wf3zbp5">
          <p className="inline-block rounded-full bg-rose px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-white" data-id="element-50" data-mp="18mo5cn80ppow">Before</p>
          <h3 className="mt-3 font-serif text-2xl font-bold text-ink" data-id="element-51" data-mp="13omrcgpg8gka">Before Facelift Blueprint™</h3>
          <p className="mt-1 text-[15px] text-muted" data-id="element-52" data-mp="3af2mhk2qmq49">You may find yourself:</p>
          <ul className="mt-5 space-y-3.5" data-id="element-53" data-mp="35fg7p679h1tc">
            {beforeItems.map(item => <li key={item} className="flex gap-3 text-[15px] leading-snug text-ink" data-id="element-54" data-mp="36orz7bsqu9u2">
                <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-rose/15 text-rose" data-id="element-55" data-mp="3bnmg2875hobj">
                  <XIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-56" data-mp="3gmzbvig025q9" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl bg-navy p-6 text-white sm:p-8" data-id="element-57" data-mp="3pf1792b7ovto">
          <p className="inline-block rounded-full bg-cta px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-white" data-id="element-58" data-mp="3perfpaaiqglv">After</p>
          <h3 className="mt-3 font-serif text-2xl font-bold" data-id="element-59" data-mp="382pjgxv6k06">After Using Facelift Blueprint™</h3>
          <p className="mt-1 text-[15px] text-white/70" data-id="element-60" data-mp="86md1ls3w3un">You'll have a repeatable educational framework to help you:</p>
          <ul className="mt-5 space-y-3.5" data-id="element-61" data-mp="24zxxblh024d4">
            {afterItems.map(item => <li key={item} className="flex gap-3 text-[15px] leading-snug" data-id="element-62" data-mp="29xzjif9q2jst">
                <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-cta text-white" data-id="element-63" data-mp="2a03rb8aqs2yd">
                  <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-64" data-mp="1wyhzca2yb4rs" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <p className="mx-auto mt-10 max-w-2xl text-center text-[17px] leading-relaxed text-ink/90" data-id="element-65" data-mp="26wxmk1yuxtw0">
        The goal isn't to give you more information.{" "}
        <strong className="text-ink" data-id="element-66" data-mp="2kumaxjs4vj5t">It's to help you get more value from the information you're already studying.</strong>
      </p>
    </Section>;
}